import { ExportColumn } from '../../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'name',
    header: 'Business Function',
    type: 'text',
  },
  {
    key: 'description',
    header: 'Description',
    type: 'text',
    width: 50,
  },
];
